const baseUrl = process.env.REACT_APP_BASE_URL;
export const trackUrl = baseUrl + "log_events/track";
